import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 1H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM3 2h13c.551 0 1 .449 1 1v1H2V3c0-.551.449-1 1-1zm13 17H3c-.551 0-1-.449-1-1V5h15v13c0 .551-.449 1-1 1z',
    'M4 8h1v1H4V8zM14.5 8h-7c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM4 11h1v1H4v-1zM14.5 11h-7c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM4 14h1v1H4v-1zM14.5 14h-7c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z',
  ],
  height: 20,
  width: 20,
});
